import { rem } from 'polished';
import styled, { breakpoints } from '../../../styles/theme';
import { CheckoutCarMainInfoStyled } from '../CheckoutCarMainInfoStyled';
import { media } from '../../../styles/media';

export const CheckoutCarMainInfoStyledDS = styled(CheckoutCarMainInfoStyled)`
    .detailsLink {
        display: flex;
        justify-content: left;
        color: ${({ theme }) => theme.colors.primary};
        font-family: ${({ theme }) => theme.fonts.fontBase};
        margin: 0;
    }
    .carInfoHeader {
        .title {
            font-family: ${({ theme }) => theme.fonts.fontBase};
            font-size: ${rem(26)};
            color: ${({ theme }) => theme.colors.black1};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: ${rem(30)};
            letter-spacing: ${rem(0.5)};
            text-transform: uppercase;
        }

        .car-model {
            letter-spacing: ${rem(0.5)};
            font-size: ${rem(26)};
            display: inline-grid;
            font-style: normal;
            color: ${({ theme }) => theme.colors.black1};
            font-family: DSAutomobiles;

            span:first-child,
            span:nth-child(2) {
                text-transform: uppercase;
            }

            span:first-child {
                font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
            }

            span:nth-child(2) {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            }

            span:last-child {
                font-weight: ${({ theme }) => theme.fontWeights.textLight};
            }
        }
    }
    .carInfo {
        font-family: ${({ theme }) => theme.fonts.fontBase};
    }

    .viewMore {
        margin-top: 0;
    }

    .paragraph {
        font-size: ${rem(14)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        span:first-child {
            font-weight: normal;
            text-transform: uppercase;
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }
    }

    .mobileCarDelivery {
        border: none;
        ${media.sm`
            padding-bottom: ${rem(25)};
        `}
    }

    .separatorLine {
        border: ${rem(0.5)} solid #cdcdcd;
    }

    .carImageWrapper {
        display: flex;
        justify-content: center;
        flex-direction: column;
        ${media.sm`
            flex-direction: row;
        `}
    }

    .availabilityStock {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        line-height: ${({ theme }) => theme.fontSizes.h3};
        color: #787b80;

        .leadTimeDate {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .optionsWrapperTitle {
        margin: 0;
        line-height: ${rem(20)};
        font-size: ${rem(16)};
        background-color: ${({ theme }) => theme.colors.accordionSecondaryBg};
        padding: ${rem(8)} ${rem(16)};
        text-transform: uppercase;

        @media (min-width: ${breakpoints.xs}px) {
            font-size: ${rem(14)};
            background-color: ${({ theme }) => theme.colors.white};
            padding: 0;
        }
    }

    .availableInLabel {
        font-size: ${rem(14)};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        color: ${({ theme }) => theme.colors.black1};
    }

    .availableInDate {
        color: ${({ theme }) => theme.colors.black1};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        font-size: ${rem(14)};
    }

    .detailsContent {
        font-family: ${({ theme }) => theme.fonts.fontBase};

        .paragraph {
            margin: ${rem(12)} 0;
            span {
                text-transform: uppercase;
            }
            span:first-child {
                max-width: 90%;
            }
            span:last-child {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }
        }
    }

    .priceSummary {
        font-family: ${({ theme }) => theme.fonts.fontBase};

        .priceInfoWrapper {
            font-size: ${rem(14)};
            line-height: ${rem(21)};
            color: #000;
            span:first-child {
                white-space: nowrap;
                text-transform: uppercase;
            }

            &NoBold {
                font-weight: normal;
            }

            &.totalPriceInfo {
                font-size: ${rem(16)};
                line-height: ${rem(21)};
                font-weight: bold;
            }
        }
    }
`;
